import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleLeft = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M21 23.875a1.142 1.142 0 0 1-1.947.791l-8-7.875a1.112 1.112 0 0 1-.339-.791c0-.3.125-.58.339-.791l8-7.875A1.142 1.142 0 0 1 21 8.125v15.75Z" }));
const ForwardRef = forwardRef(SvgTriangleLeft);
export default ForwardRef;
